/* dev-collection-grid.js */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-collection-grid]').forEach(el => init(el));
});

function init(section) {
  const productGrid  = section.querySelector('[data-products-grid]');
  const searchInput  = section.querySelector('[data-search-input]');
  if (!productGrid) return;

  // ── State ────────────────────────────────────────────────────
  // activeFilters: Map<paramName, Set<value>>
  const activeFilters = new Map();
  let currentSort = 'manual';

  // Store original DOM order once
  productGrid.querySelectorAll('.collection-grid__card-slot')
    .forEach((slot, i) => { slot.dataset.originalIndex = i; });

  // ── Unified dropdown management ──────────────────────────────
  // Both filter wraps and sort wrap use data-dropdown-wrap / data-toggle / data-dropdown

  const dropdownWraps = section.querySelectorAll('[data-dropdown-wrap]');

  function closeAllDropdowns() {
    dropdownWraps.forEach(wrap => {
      const toggle   = wrap.querySelector('[data-toggle]');
      const dropdown = wrap.querySelector('[data-dropdown]');
      toggle?.setAttribute('aria-expanded', 'false');
      dropdown?.classList.remove('is-open');
    });
  }

  dropdownWraps.forEach(wrap => {
    const toggle   = wrap.querySelector('[data-toggle]');
    const dropdown = wrap.querySelector('[data-dropdown]');
    if (!toggle || !dropdown) return;

    toggle.addEventListener('click', () => {
      const isOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        dropdown.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close all when clicking outside every dropdown wrap
  document.addEventListener('click', (e) => {
    const inAnyWrap = [...dropdownWraps].some(w => w.contains(e.target));
    if (!inAnyWrap) closeAllDropdowns();
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  // ── Filter option clicks (list filters) ──────────────────────

  section.addEventListener('click', (e) => {
    const option = e.target.closest('[data-filter-param][data-filter-value]');
    if (!option) return;

    const param = option.dataset.filterParam;
    const value = option.dataset.filterValue;

    if (!activeFilters.has(param)) activeFilters.set(param, new Set());
    const set = activeFilters.get(param);

    if (set.has(value)) {
      set.delete(value);
      option.setAttribute('aria-selected', 'false');
    } else {
      set.add(value);
      option.setAttribute('aria-selected', 'true');
    }

    if (set.size === 0) activeFilters.delete(param);

    closeAllDropdowns();
    fetchFiltered();
  });

  // ── Price range filter ───────────────────────────────────────

  section.addEventListener('click', (e) => {
    const applyBtn = e.target.closest('[data-price-apply]');
    if (!applyBtn) return;

    const pricePanel = applyBtn.closest('[data-filter-price]');
    if (!pricePanel) return;

    const param       = pricePanel.dataset.filterParam;
    const minInput    = pricePanel.querySelector('[data-price-min]');
    const maxInput    = pricePanel.querySelector('[data-price-max]');
    const priceMaxVal = parseFloat(pricePanel.dataset.priceMaxVal) || 0;

    activeFilters.delete(`${param}.gte`);
    activeFilters.delete(`${param}.lte`);

    const minVal = parseFloat(minInput?.value || 0);
    const maxVal = parseFloat(maxInput?.value || priceMaxVal);

    // Slider values are in cents (matching filter.range_max).
    // Shopify price filter URL params expect dollars — divide by 100.
    if (minVal > 0) activeFilters.set(`${param}.gte`, new Set([minVal / 100]));
    if (priceMaxVal > 0 && maxVal < priceMaxVal) activeFilters.set(`${param}.lte`, new Set([maxVal / 100]));

    closeAllDropdowns();
    fetchFiltered();
  });

  // ── Dual-handle range slider ─────────────────────────────────

  function initPriceSliders() {
    section.querySelectorAll('[data-filter-price]').forEach(panel => {
      const minInput    = panel.querySelector('[data-price-min]');
      const maxInput    = panel.querySelector('[data-price-max]');
      const fill        = panel.querySelector('[data-range-fill]');
      const labelMin    = panel.querySelector('[data-price-label-min]');
      const labelMax    = panel.querySelector('[data-price-label-max]');
      if (!minInput || !maxInput || !fill) return;

      const priceMax = parseFloat(panel.dataset.priceMaxVal) || 100;

      const fmt = (cents) => '$' + Math.round(cents / 100).toLocaleString('en-US');

      function updateFill() {
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);
        const minPct = (minVal / priceMax) * 100;
        const maxPct = (maxVal / priceMax) * 100;
        fill.style.left  = minPct + '%';
        fill.style.width = (maxPct - minPct) + '%';
        if (labelMin) labelMin.textContent = fmt(minVal);
        if (labelMax) labelMax.textContent = fmt(maxVal);
        // Keep min thumb on top when handles meet so user can drag left
        minInput.style.zIndex = minVal >= maxVal - 1 ? '5' : '';
      }

      minInput.addEventListener('input', () => {
        if (parseFloat(minInput.value) >= parseFloat(maxInput.value)) {
          minInput.value = String(parseFloat(maxInput.value) - 1);
        }
        updateFill();
      });

      maxInput.addEventListener('input', () => {
        if (parseFloat(maxInput.value) <= parseFloat(minInput.value)) {
          maxInput.value = String(parseFloat(minInput.value) + 1);
        }
        updateFill();
      });

      updateFill();
    });
  }

  initPriceSliders();

  // ── Sort clicks ──────────────────────────────────────────────

  section.addEventListener('click', (e) => {
    const sortOption = e.target.closest('[data-sort]');
    if (!sortOption) return;

    currentSort = sortOption.dataset.sort;

    // Update aria-selected on all sort options
    section.querySelectorAll('[data-sort]').forEach(o => {
      o.setAttribute('aria-selected', o === sortOption ? 'true' : 'false');
    });

    // Update sort button label (exclude the checkbox span text)
    const labelEl = section.querySelector('[data-sort-label]');
    if (labelEl) {
      const clone = sortOption.cloneNode(true);
      clone.querySelector('.collection-grid__sort-check')?.remove();
      labelEl.textContent = clone.textContent.trim();
    }

    closeAllDropdowns();
    fetchFiltered();
  });

  // ── Mobile drawer ─────────────────────────────────────────────

  const drawerOverlay  = section.querySelector('[data-mobile-drawer-overlay]');
  const drawer         = section.querySelector('[data-mobile-drawer]');
  const drawerOpenBtn  = section.querySelector('[data-mobile-drawer-open]');
  const drawerCloseBtn = section.querySelector('[data-mobile-drawer-close]');

  function openDrawer() {
    drawer?.classList.add('is-open');
    drawerOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer?.classList.remove('is-open');
    drawerOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  drawerOpenBtn?.addEventListener('click', openDrawer);
  drawerCloseBtn?.addEventListener('click', closeDrawer);
  drawerOverlay?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // Mobile sort select
  const mobileSortSelect = section.querySelector('[data-mobile-sort]');
  mobileSortSelect?.addEventListener('change', () => {
    currentSort = mobileSortSelect.value;
    const labelEl = section.querySelector('[data-sort-label]');
    if (labelEl) {
      labelEl.textContent = mobileSortSelect.options[mobileSortSelect.selectedIndex]?.text || '';
    }
    fetchFiltered();
  });

  // Mobile filter selects (single-select per filter param)
  section.querySelectorAll('[data-mobile-filter]').forEach(sel => {
    sel.addEventListener('change', () => {
      const param = sel.dataset.mobileFilter;
      if (sel.value === '') {
        activeFilters.delete(param);
      } else {
        activeFilters.set(param, new Set([sel.value]));
      }
      fetchFiltered();
    });
  });

  // ── Search (client-side, instant) ───────────────────────────

  // ── Predictive search — Shopify Search Suggest API ──────────
  // Real server-side search across the whole catalog (typo/prefix tolerant),
  // rendered as an autocomplete dropdown — not a client-side filter of the
  // already-rendered cards.
  const searchWrap    = section.querySelector('[data-search-wrap]');
  const searchResults = section.querySelector('[data-search-results]');
  let   searchTimer;

  function hideSearchResults() {
    if (searchResults) searchResults.hidden = true;
  }

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (m) => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]
    ));
  }

  function renderSearchResults(products, q) {
    if (!searchResults) return;
    if (!products.length) {
      searchResults.innerHTML =
        '<div class="collection-grid__search-empty">No products for &ldquo;' + escHtml(q) + '&rdquo;</div>';
      searchResults.hidden = false;
      return;
    }
    searchResults.innerHTML = products.map((p) => {
      const img   = (p.featured_image && p.featured_image.url) || p.image || '';
      const thumb = img
        ? '<img src="' + img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=88" alt="" loading="lazy">'
        : '';
      const meta  = p.product_type || p.vendor || '';
      return '<a class="collection-grid__search-result" href="' + p.url + '">'
        +    '<span class="collection-grid__search-thumb">' + thumb + '</span>'
        +    '<span class="collection-grid__search-info">'
        +      '<span class="collection-grid__search-title">' + escHtml(p.title) + '</span>'
        +      (meta ? '<span class="collection-grid__search-meta">' + escHtml(meta) + '</span>' : '')
        +    '</span>'
        +  '</a>';
    }).join('');
    searchResults.hidden = false;
  }

  async function runSearch(q) {
    const url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product&resources[limit]=8'
      + '&resources[options][unavailable_products]=last';
    try {
      const resp = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!resp.ok) return;
      const data = await resp.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      renderSearchResults(products, q);
    } catch (err) {
      console.error('[collection-grid] search failed:', err);
    }
  }

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { hideSearchResults(); return; }
      searchTimer = setTimeout(() => runSearch(q), 220);
    });
    searchInput.addEventListener('focus', () => {
      if (searchResults && searchResults.innerHTML && searchInput.value.trim().length >= 2) {
        searchResults.hidden = false;
      }
    });
  }

  document.addEventListener('click', (e) => {
    if (searchWrap && !searchWrap.contains(e.target)) hideSearchResults();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') hideSearchResults();
  });

  // ── Section Rendering API ────────────────────────────────────

  async function fetchFiltered() {
    const handle    = section.dataset.collectionHandle;
    const sectionId = section.dataset.sectionId;
    if (!handle || !sectionId) return;

    const url = new URL(`/collections/${handle}`, window.location.origin);
    url.searchParams.set('sections', sectionId);

    // Shopify sort_by param (omit for featured/default)
    if (currentSort && currentSort !== 'manual') {
      url.searchParams.set('sort_by', currentSort);
    }

    // Active filter params
    activeFilters.forEach((values, param) => {
      values.forEach(val => url.searchParams.append(param, val));
    });

    productGrid.classList.add('is-loading');

    try {
      const resp = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!resp.ok) return;

      const json = await resp.json();
      const html = json[sectionId];
      if (!html) return;

      const doc     = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-products-grid]');
      if (!newGrid) return;

      productGrid.innerHTML = newGrid.innerHTML;

      // Re-index slots for local sort
      productGrid.querySelectorAll('.collection-grid__card-slot')
        .forEach((slot, i) => { slot.dataset.originalIndex = i; });

    } catch (err) {
      console.error('[collection-grid] filter fetch failed:', err);
    } finally {
      productGrid.classList.remove('is-loading');
    }
  }
}
